(() => {
  const STORAGE_KEY = 'theme-recent';
  const SESSION_KEY = 'recent-products';
  const IMAGE_WIDTHS = [260, 360, 520, 720, 900];

  const WISHLIST_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="14" viewBox="0 0 16 14" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.10309 2.23725C9.66513 1.6393 10.4294 1.27162 11.2474 1.20565C12.0653 1.13969 12.8786 1.38014 13.5292 1.8803C15.195 3.30809 14.957 5.58066 13.7553 6.79428L8.05604 12.6125C7.99655 12.6839 7.93706 12.6839 7.82998 12.6125L2.14261 6.78238C1.82145 6.45533 1.57124 6.06552 1.40762 5.63734C1.244 5.20916 1.1705 4.75182 1.19172 4.29394C1.21294 3.83605 1.32842 3.38747 1.53094 2.97626C1.73345 2.56505 2.01865 2.20005 2.36868 1.9041C3.62989 0.833257 5.58121 0.999832 6.81863 2.23725L7.96086 3.40328L9.10309 2.23725ZM7.96086 1.70183L8.24642 1.40437C9.01567 0.592394 10.0599 0.0961854 11.1753 0.0125871C12.2906 -0.0710112 13.3971 0.264 14.2788 0.952239L14.2907 0.964137V0.976036C14.7677 1.3797 15.1563 1.87737 15.4322 2.43797C15.7082 2.99856 15.8656 3.61003 15.8946 4.23419C15.9237 4.85835 15.8237 5.4818 15.6009 6.06558C15.3782 6.64937 15.0375 7.18096 14.6001 7.62716L8.90082 13.4573C8.67735 13.6826 8.38081 13.8208 8.06454 13.847C7.74827 13.8732 7.43304 13.7856 7.17557 13.6001L7.05659 13.5287L1.29784 7.62716C0.861025 7.18303 0.520701 6.65343 0.298213 6.07158C0.0757245 5.48973 -0.0241283 4.86818 0.00491798 4.24592C0.0339642 3.62366 0.191283 3.01412 0.467006 2.45552C0.742729 1.89693 1.13091 1.40134 1.60719 0.999832C2.48533 0.296509 3.59466 -0.0531551 4.71738 0.0194918C5.84011 0.0921387 6.89512 0.581849 7.6753 1.39247L7.6872 1.40437L7.97276 1.70183H7.96086Z" fill="#1C1C1C"/></svg>';

  const escapeHtml = (value) =>
    String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');

  const getRecentProducts = () => {
    if (window.theme?.recentlyViewed?.recent && Object.keys(theme.recentlyViewed.recent).length) {
      return theme.recentlyViewed.recent;
    }

    try {
      const stored = window.localStorage.getItem(STORAGE_KEY);
      return stored ? JSON.parse(stored) : {};
    } catch {
      return {};
    }
  };

  const getCachedProductInfo = () => {
    if (window.theme?.recentlyViewed?.productInfo) {
      return theme.recentlyViewed.productInfo;
    }

    try {
      const stored = window.sessionStorage.getItem(SESSION_KEY);
      return stored ? JSON.parse(stored) : {};
    } catch {
      return {};
    }
  };

  const formatMoney = (cents) => {
    let formatted;

    if (window.theme?.Currency?.formatMoney) {
      formatted = theme.Currency.formatMoney(cents, theme.moneyFormat);
    } else {
      const amount = Number(cents) / 100;
      formatted = amount.toLocaleString(undefined, {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'USD',
        minimumFractionDigits: Number.isInteger(amount) ? 0 : 2,
        maximumFractionDigits: 2,
      });
    }

    return formatted.replace(/([.,]0+)(<\/sup>)?$/, (_, _decimalZeros, sup) => sup || '');
  };

  const buildImageUrl = (url, width) => {
    if (!url) return '';
    return width ? `${url}?width=${width}` : url;
  };

  const buildMeta = (product) => {
    const parts = [];

    if (product.vendor) parts.push(product.vendor);
    if (product.type) parts.push(product.type);

    const variant = product.variants?.[0];
    const sizeText =
      variant?.title && variant.title !== 'Default Title' ? variant.title : '';

    if (sizeText) parts.push(sizeText);

    return parts.join(' · ');
  };

  const buildBadge = (product) => {
    const onSale =
      product.compare_at_price && Number(product.compare_at_price) > Number(product.price);

    if (onSale) {
      const discount = Math.round(
        ((product.compare_at_price - product.price) * 100) / product.compare_at_price
      );
      return `<span class="mcc-product-card__badge">-${discount}%</span>`;
    }

    const tags = (product.tags || []).map((tag) => tag.toLowerCase());
    if (tags.includes('new')) {
      return '<span class="mcc-product-card__badge mcc-product-card__badge--new">New</span>';
    }

    return '';
  };

  const buildProductCard = (product, recentEntry) => {
    const url = recentEntry?.url || product.url;
    const featuredImage = product.featured_image;
    const onSale =
      product.compare_at_price && Number(product.compare_at_price) > Number(product.price);
    const meta = buildMeta(product);

    let imageMarkup = '';

    if (featuredImage) {
      const src = buildImageUrl(featuredImage, 520);
      const srcset = IMAGE_WIDTHS.map((width) => {
        return `${buildImageUrl(featuredImage, width)} ${width}w`;
      }).join(', ');

      imageMarkup = `<img class="mcc-product-card__image" src="${escapeHtml(src)}" srcset="${escapeHtml(srcset)}" sizes="(max-width: 767px) 48vw, 20vw" loading="lazy" alt="${escapeHtml(product.title)}">`;
    } else {
      imageMarkup = '<div class="mcc-product-card__placeholder"></div>';
    }

    const compareMarkup = onSale
      ? `<span class="mcc-product-card__compare">${formatMoney(product.compare_at_price)}</span>`
      : '';

    const metaMarkup = meta
      ? `<p class="mcc-product-card__meta">${escapeHtml(meta)}</p>`
      : '';

    return `
      <article class="mcc-product-card" data-product-id="${product.id}">
        <a class="mcc-product-card__media-link" href="${escapeHtml(url)}" aria-label="${escapeHtml(product.title)}">
          <div class="mcc-product-card__media">
            ${imageMarkup}
            ${buildBadge(product)}
          </div>
        </a>
        <div class="mcc-product-card__body">
          <a class="mcc-product-card__title" href="${escapeHtml(url)}">${escapeHtml(product.title)}</a>
          ${metaMarkup}
          <div class="mcc-product-card__bottom">
            <div class="mcc-product-card__price">
              ${compareMarkup}
              <span>${formatMoney(product.price)}</span>
            </div>
            <button class="mcc-product-card__wishlist" type="button" aria-label="Add ${escapeHtml(product.title)} to wishlist">
              ${WISHLIST_SVG}
            </button>
          </div>
        </div>
      </article>
    `;
  };

  const fetchProduct = async (handle, cache) => {
    if (cache[handle]) {
      return typeof cache[handle] === 'string' ? JSON.parse(cache[handle]) : cache[handle];
    }

    const response = await fetch(`/products/${handle}.js`);
    if (!response.ok) return null;
    return response.json();
  };

  const saveProductCache = (products) => {
    const cache = getCachedProductInfo();

    products.forEach((product) => {
      if (product?.handle) {
        cache[product.handle] = product;
      }
    });

    if (window.theme?.recentlyViewed) {
      theme.recentlyViewed.productInfo = cache;
    }

    try {
      window.sessionStorage.setItem(SESSION_KEY, JSON.stringify(cache));
    } catch {
      /* ignore */
    }
  };

  const waitForSwiper = () =>
    new Promise((resolve) => {
      if (window.Swiper) {
        resolve(window.Swiper);
        return;
      }

      const started = Date.now();
      const timer = window.setInterval(() => {
        if (window.Swiper) {
          window.clearInterval(timer);
          resolve(window.Swiper);
          return;
        }

        if (Date.now() - started > 5000) {
          window.clearInterval(timer);
          resolve(null);
        }
      }, 50);
    });

  const initSlider = async (root) => {
    const swiperEl = root.querySelector('[data-mcc-recently-swiper]');

    if (!swiperEl) return;

    const Swiper = await waitForSwiper();
    if (!Swiper) return;

    if (root._mccRecentlySwiper) {
      root._mccRecentlySwiper.destroy(true, true);
      root._mccRecentlySwiper = null;
    }

    root._mccRecentlySwiper = new Swiper(swiperEl, {
      slidesPerView: 1.5,
      spaceBetween: 40,
      grabCursor: true,
      watchOverflow: true,
      breakpoints: {
        990: {
          enabled: false,
          slidesPerView: 5,
          spaceBetween: 25,
        },
      },
    });
  };

  const initSection = async (root) => {
    const recent = getRecentProducts();
    const handles = Object.keys(recent).filter((handle) => handle && handle !== 'undefined');

    if (!handles.length) return;

    const currentHandle = root.getAttribute('data-product-handle');
    const limit = Number(root.getAttribute('data-limit')) || 5;
    const cache = getCachedProductInfo();
    const orderedHandles = handles.filter((handle) => handle !== currentHandle).slice(-limit).reverse();

    if (!orderedHandles.length) return;

    const products = (
      await Promise.all(orderedHandles.map((handle) => fetchProduct(handle, cache)))
    ).filter(Boolean);

    if (!products.length) return;

    const track = root.querySelector('[data-mcc-recently-track]');
    if (!track) return;

    track.innerHTML = products
      .map(
        (product) =>
          `<div class="swiper-slide">${buildProductCard(product, recent[product.handle])}</div>`
      )
      .join('');

    saveProductCache(products);
    root.hidden = false;
    await initSlider(root);
  };

  const boot = () => {
    document.querySelectorAll('[data-mcc-recently-viewed]').forEach((root) => {
      initSection(root);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector?.('[data-mcc-recently-viewed]');
    if (root) initSection(root);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const root = event.target.querySelector?.('[data-mcc-recently-viewed]');

    if (root?._mccRecentlySwiper) {
      root._mccRecentlySwiper.destroy(true, true);
      root._mccRecentlySwiper = null;
    }
  });
})();
